import { useCallback, useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { exportReportFile, processReport } from '../../../../utils/reports';
import { DETAILED_SIGNUP_FUNNEL_COLUMNS } from '../../../../constants/reports';
import ReportList from '../ReportList';
import ReportActionRow from '../ReportActionRow';

function ReportDetailedSignupFunnel({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport, groups } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              value !== null
                ? applyExcelFormats(value, DETAILED_SIGNUP_FUNNEL_COLUMNS[key]?.style?.numFmt)
                : null,
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  const formatCellConditionally = useCallback(({ reportItem, tableColumnKey }) => {
    if (
      (tableColumnKey === 'openLink' ||
        tableColumnKey === 'page1' ||
        tableColumnKey === 'page2' ||
        tableColumnKey === 'verification' ||
        tableColumnKey === 'consumer' ||
        tableColumnKey === 'account') &&
      reportItem[tableColumnKey] === 'ok'
    ) {
      return ' bg-success text-success';
    }

    if (
      (tableColumnKey === 'openLink' ||
        tableColumnKey === 'page1' ||
        tableColumnKey === 'page2' ||
        tableColumnKey === 'verification' ||
        tableColumnKey === 'consumer' ||
        tableColumnKey === 'account') &&
      reportItem[tableColumnKey] &&
      reportItem[tableColumnKey] !== 'ok'
    ) {
      return ' bg-danger text-white';
    }

    return '';
  }, []);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={DETAILED_SIGNUP_FUNNEL_COLUMNS}
        headerHeight={36}
        groups={groups}
        rowKey="uuid"
        formatCellConditionally={formatCellConditionally}
      />
    </>
  );
}

export default ReportDetailedSignupFunnel;
